import { Page } from '../../types'

type ClientCSharpDockerProps = {
    packageManager: string,
    requiresFullInstallation: boolean
}

const getDockerfile = ({ requiresFullInstallation }: ClientCSharpDockerProps) => 
`FROM mcr.microsoft.com/dotnet/sdk:6.0 AS build
WORKDIR /app
COPY . ./
RUN dotnet restore
RUN dotnet publish -c Release -o out

FROM mcr.microsoft.com/dotnet/runtime:6.0
WORKDIR /app
COPY --from=build /app/out .
ENTRYPOINT ["dotnet", "project.dll"]`

const render = (props : ClientCSharpDockerProps) => {
    return <>
        <p>Below is an example of a Dockerfile that uses a multi-stage approach to minimize the final container image size.
            Make sure you replace <code>project.dll</code> by the name of your project and pick the version of the .NET base images
            that match your application.
        </p>
        <pre>{getDockerfile(props)}</pre>
    </>
}

const ClientCSharpDocker : Page<ClientCSharpDockerProps> = { key: 'client-csharp-docker', title: 'Create a Dockerfile', render }

export default ClientCSharpDocker